module.exports = __webpack_public_path__ + "static/media/portfolio.684a399a.png";